import React, { useEffect, useMemo, useState } from "react";
import ReactHlsPlayer from "react-hls-player";
import { useUser } from "../../context/UserContext";
import useWakeLock from "../../hooks/useWakeLock";
import { Api } from "../../services/api";

export default function LiveVideo() {
  const { user } = useUser();
  const api = useMemo(() => new Api(), []);
  const [liveVideo, setLiveVideo] = useState(null);
  const [promoVideo, setPromoVideo] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const playerRef = React.useRef();

  useWakeLock(playerRef);

  useEffect(() => {
    const handleReload = () => setRefreshKey((k) => k + 1);
    window.addEventListener("reload-live-data", handleReload);
    return () => window.removeEventListener("reload-live-data", handleReload);
  }, []);

  useEffect(() => {
    const getData = async () => {
      const response = await api.getWithAuth(
        "/api/sessionvideos?where[status][equals]=live&where[isPublished][equals]=true",
        user,
      );
      const json = await response.json();
      if (json.docs && json.docs.length > 0) {
        setLiveVideo(json.docs[0]);
      } else {
        setLiveVideo(null);
        const promoResponse = await api.getWithAuth(
          "/api/videos?where[tags.slug][in]=promovideo&limit=1&page=1&sort=-updatedAt&locale=it",
          user,
        );
        const promoJson = await promoResponse.json();
        if (promoJson.docs && promoJson.docs.length > 0) {
          setPromoVideo(promoJson.docs[0]);
        }
      }
    };
    getData();
  }, [user, api, refreshKey]);

  const videoToShow = liveVideo || promoVideo;
  const videoUrl = liveVideo ? liveVideo.liveUrl : promoVideo?.url;
  const isMP4 = videoUrl?.toLowerCase().endsWith(".mp4");

  return (
    videoToShow && (
      <div
        id="live-video-section"
        data-is-live={!!liveVideo}
        className="col-span-full px-4 py-2 bg-ecweek-secondary"
      >
        <div className="max-w-6xl mx-auto">
          <h3 className="text-xl font-semibold mb-1 text-center text-white">
            {liveVideo
              ? (liveVideo.session?.title || liveVideo.title) +
                " - ( 🔴 Live streaming!)"
              : promoVideo.title}
          </h3>
          <div className="w-4/5 mx-auto">
            {isMP4 ? (
              <video
                key={videoUrl}
                ref={playerRef}
                src={videoUrl}
                autoPlay={true}
                muted={true}
                loop={true}
                controls={true}
                className="w-full block"
                onContextMenu={(e) => e.preventDefault()}
                controlsList="nodownload"
              />
            ) : (
              <ReactHlsPlayer
                key={videoUrl}
                playerRef={playerRef}
                src={videoUrl}
                autoPlay={true}
                muted={true}
                controls={true}
                className="w-full block"
                onContextMenu={(e) => e.preventDefault()}
                controlsList="nodownload"
              />
            )}
          </div>
        </div>
      </div>
    )
  );
}
